module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"qa":"常见问题","back":"返回"},"en":{"qa":"Frequently Asked Questions","back":"Back"}}')
  delete Component.options._Ctor
}
